import { env } from "@/shared/config/env";

const MIXED_CONTENT_WARNING =
  "VITE_API_BASE_URL uses http:// while this page is https://. Browsers block those API requests. Use https:// in .env.local and restart the dev server.";

/**
 * Returns a mixed-content warning when the page is HTTPS but the API base URL is HTTP.
 */
export function getMixedContentApiWarning(
  pageProtocol: string,
  apiBaseUrl: string,
): string | null {
  if (!apiBaseUrl || pageProtocol !== "https:") {
    return null;
  }

  try {
    if (new URL(apiBaseUrl).protocol === "http:") {
      return MIXED_CONTENT_WARNING;
    }
  } catch {
    return null;
  }

  return null;
}

/** Dev-only: log API config and warn about mixed-content misconfiguration. */
export function logDevEnvSanity(): void {
  if (!env.isDev) {
    return;
  }

  const apiBaseUrl = env.apiBaseUrl || "(not set)";
  console.info("[olive-ui] VITE_API_BASE_URL:", apiBaseUrl);

  const mixedContentWarning = getMixedContentApiWarning(
    window.location.protocol,
    env.apiBaseUrl,
  );
  if (mixedContentWarning) {
    console.warn(`[olive-ui] ${mixedContentWarning}`);
  }
}
